import { FC } from 'react'

interface Props {
  width?: number | string
  height?: number | string
}

const TryOnHand: FC<Props> = ({ width, height, ...props }) => {
  return (
    <svg
      width={width || '18'}
      height={height || '15'}
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.36115 0L6.68278 1.91056H4.81359L6.30312 0H7.36115ZM10.7893 1.91056L10.1108 0H7.89149L7.21313 1.91056H10.7893ZM13.1872 1.91056L11.6976 0H10.6397L11.3181 1.91056H13.1872ZM8.22097 6.18045L6.69155 2.42883H4.86328L8.22097 6.18045ZM10.77 2.42883L9.12327 6.46825C9.08249 6.46733 9.04156 6.46702 9.00079 6.46702C8.95971 6.46702 8.91893 6.46733 8.87816 6.46825L7.23141 2.42883H10.77ZM11.1288 4.67398L13.1383 2.42883H11.3099L9.78047 6.18045L11.1288 4.67398ZM17.9977 14.4C17.9992 14.3285 18 14.2569 18 14.185C18 9.95276 15.2895 6.25545 11.39 5.14032L10.1244 6.55444C11.6759 6.79913 13.1072 7.54946 14.2375 8.72718C15.6365 10.185 16.407 12.1233 16.407 14.185C16.407 14.2568 16.406 14.3285 16.4042 14.4H17.9977ZM1.59611 14.4C1.59425 14.3285 1.59331 14.2568 1.59331 14.185C1.59331 12.1233 2.36383 10.185 3.76282 8.72718C4.89299 7.54946 6.32422 6.79913 7.87572 6.55444L6.61011 5.14032C2.71053 6.25545 0 9.95276 0 14.185C0 14.2569 0.000779344 14.3285 0.00232969 14.4H1.59611Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default TryOnHand
